import {startOfWeek, parse, format, parseISO} from 'date-fns'

export default {
    state: {
        productionOrders: [],
        dateProductionOrder: [],
        weekCapacity: [],
        sourceDragDrop: null,
        destinationDragDrop: null,
        selectedRow: null,
        selectedColumn: null,
        selectedWeekYear: null,
        selectedWeek: null,
        dateProductionOrderPerPage: 7,
        dateProductionOrderCurrentPage: 1,
        holiday: [],
        saveDownloadDisable: false,
    },

    actions: {
        async fetchProductionOrder(ctx) {
            const toastWaitId = this._vm.$toast("Loading ...", {timeout: 60000,})
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    // "Authorization": 'Token ' + ctx.rootState.ComponentDBAuthorization.token
                    'credentials': "same-origin",
                },
            };
            let res = await fetch("/api/productionorder/", requestParams);
            let productionOrders = await res.json();
            if (!res.ok) {
                this._vm.$toast.dismiss(toastWaitId)
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                return
            }
            res = await fetch("/api/holiday/", requestParams);
            const holiday = await res.json();
            if (!res.ok) {
                this._vm.$toast.dismiss(toastWaitId)
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                return
            }
            res = await fetch("/api/weekcapacity/", requestParams);
            const weekCapacity = await res.json();
            if (!res.ok) {
                this._vm.$toast.dismiss(toastWaitId)
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                return
            }
            for (let productionOrder of productionOrders) {
                if (productionOrder.delivery_date != null)
                    productionOrder.delivery_date = parseISO(productionOrder.delivery_date)
                if (productionOrder.start_delivery_date != null)
                    productionOrder.start_delivery_date = parseISO(productionOrder.start_delivery_date)
            }
            ctx.commit('updateProductionOrders', productionOrders)
            ctx.commit('updateHoliday', holiday)
            ctx.commit('updateWeekCapacity', weekCapacity)
            // console.log('weekCapacity')
            // console.log(weekCapacity)
            this._vm.$toast.dismiss(toastWaitId)
            this._vm.$toast.success("Success")
        },
        async fetchUpdateFromNotion(ctx) {
            ctx.commit('updateSaveDownloadDisable', true)
            const toastWaitId = this._vm.$toast("Updating from Notion ...", {timeout: 120000,})
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            let res = await fetch("/product/action/update_from_notion/", requestParams)
            if (!res.ok) {
                this._vm.$toast.dismiss(toastWaitId)
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                ctx.commit('updateSaveDownloadDisable', false)
                return
            }
            this._vm.$toast.dismiss(toastWaitId)
            this._vm.$toast.success("Success update")
            ctx.dispatch('fetchProductionOrder')
            ctx.commit('updateSaveDownloadDisable', false)
        },
        async fetchUpdateToNotion(ctx) {
            ctx.commit('updateSaveDownloadDisable', true)
            const toastWaitId = this._vm.$toast("Updating to Notion ...", {timeout: 120000,})
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            let res = await fetch("/product/action/update_to_notion/", requestParams)
            if (!res.ok) {
                this._vm.$toast.dismiss(toastWaitId)
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                ctx.commit('updateSaveDownloadDisable', false)
                return
            }
            this._vm.$toast.dismiss(toastWaitId)
            this._vm.$toast.success("Success update")
            ctx.commit('updateSaveDownloadDisable', false)
        },
        async selectCell(ctx, params) {
            const row = params.rowIndex
            const column = params.column.field
            // console.log('selectCell')
            // console.log(params)
            ctx.commit('updateSelectedCell', {
                'row': row, 'column': column,
                'year': params.row.weekYear, 'week': params.row.week
            })
        },
        async startMarginScheduling(ctx, sourceDragDrop) {
            ctx.commit('updateSourceDragDrop', sourceDragDrop)
            ctx.commit('updateDestinationDragDrop', null)
        },
        async endMarginScheduling(ctx, destinationDate) {
            console.log('destinationDate')
            console.log(destinationDate)
            console.log(ctx.state.sourceDragDrop)
            if (ctx.state.sourceDragDrop != null) {
                let productionOrders = ctx.state.productionOrders
                let productionOrdersFiltered = productionOrders.filter(po => po.id == ctx.state.sourceDragDrop)
                if (productionOrdersFiltered.length > 0) {
                    productionOrdersFiltered[0].delivery_date = destinationDate
                    const currentDate = new Date(new Date().toDateString())
                    if (destinationDate != null) {
                        const startDeliveryDate = destinationDate.addDays(-13)
                        if (currentDate >= startDeliveryDate) productionOrdersFiltered[0].start_delivery_date = currentDate
                        else productionOrdersFiltered[0].start_delivery_date = startDeliveryDate
                    }
                    let csrfToken = readCookie('csrftoken')
                    const request = {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: JSON.stringify({
                            'start_delivery_date': productionOrdersFiltered[0].start_delivery_date != null ?
                                format(productionOrdersFiltered[0].start_delivery_date, 'yyyy-MM-dd') : null,
                            'delivery_date': productionOrdersFiltered[0].delivery_date != null ?
                                format(productionOrdersFiltered[0].delivery_date, 'yyyy-MM-dd') : null,
                        })
                    };
                    const res = await fetch("/api/productionorder/" + ctx.state.sourceDragDrop + "/", request)
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        return
                    } else
                        ctx.commit('updateProductionOrders', productionOrders)
                }
            }
            ctx.commit('updateSourceDragDrop', null)
        },
    },

    mutations: {
        updateSelectedCell(state, cell) {
            state.selectedRow = cell['row']
            state.selectedColumn = cell['column']
            state.selectedWeekYear = cell['year']
            state.selectedWeek = cell['week']
        },
        updateProductionOrders(state, productionOrders) {
            // console.log('Update productionOrders')
            // console.log(productionOrders)
            state.productionOrders = productionOrders
        },
        updateHoliday(state, holiday) {
            // console.log('holiday')
            // console.log(holiday)
            state.holiday = holiday
        },
        updateWeekCapacity(state, weekCapacity) {
            // console.log('weekCapacity')
            // console.log(weekCapacity)
            state.weekCapacity = weekCapacity
        },
        updateSourceDragDrop(state, sourceDragDrop) {
            state.sourceDragDrop = sourceDragDrop
        },
        updateDestinationDragDrop(state, destinationDragDrop) {
            state.destinationDragDrop = destinationDragDrop
        },
        updateDateProductionOrderPerPage(state, perPage) {
            state.dateProductionOrderPerPage = perPage
        },
        updateDateProductionOrderCurrentPage(state, currentPage) {
            state.dateProductionOrderCurrentPage = currentPage
        },
        updateSaveDownloadDisable(state, saveDownloadDisable) {
            state.saveDownloadDisable = saveDownloadDisable
        },
    },

    getters: {
        getProductionOrders(state) {
            return state.productionOrders
        },
        getEmptyProductionOrders(state) {
            return state.productionOrders.filter(po => po.delivery_date == null)
        },
        getDateProductionOrders(state) {
            // console.log('state.productionOrders')
            // console.log(state.productionOrders)
            return convertDateProductionOrders(state.productionOrders, state.holiday, state.weekCapacity)
        },
        getSelectedRow(state) {
            return state.selectedRow
        },
        getSelectedColumn(state) {
            return state.selectedColumn
        },
        getWeekProductionOrders(state) {
            return state.productionOrders.filter(po =>
                po.delivery_date != null &&
                po.week === state.selectedWeek &&
                po.weekYear === state.selectedWeekYear)
        },
        getDayProductionOrders(state) {
            return state.productionOrders.filter(po =>
                po.delivery_date != null &&
                po.week === state.selectedWeek &&
                po.weekYear === state.selectedWeekYear &&
                po.dayWeek == state.selectedColumn)
        },
        getDateProductionOrderCurrentPerPage(state) {
            return state.dateProductionOrderPerPage
        },
        getDateProductionOrderCurrentPage(state) {
            return state.dateProductionOrderCurrentPage
        },
        getDateProductionOrderCurrentPageName(state, props) {
            const name = props.firstRecordOnPage
            return name
        },
        getHoliday(state) {
            return state.holiday
        },
        getSaveDownloadDisable(state) {
            return state.saveDownloadDisable
        },
    }
}

function convertDateProductionOrders(sourceProductionOrder, publicHolidays, weekCapacity) {
    let productionOrderWeekDays = []
    let productionOrders = sourceProductionOrder.filter(productionOrder => productionOrder.delivery_date != null)
    let smd = {}
    let tht = {}
    for (let productionOrder of productionOrders) {
        productionOrder.weekYear = productionOrder.delivery_date.getWeekYear()
        productionOrder.week = productionOrder.delivery_date.getWeek()
        productionOrder.dayWeek = productionOrder.delivery_date.getDay()

        let productionOrderWeekDay = productionOrderWeekDays.filter(
            productionOrderWeekDay => productionOrderWeekDay.weekYear === productionOrder.weekYear &&
                productionOrderWeekDay.week === productionOrder.week)
        if (productionOrderWeekDay.length === 0) {
            let newProductionOrderWeekDay = {
                // [productionOrder.dayWeek]: [productionOrder.id],
                [productionOrder.dayWeek]: [productionOrder],
                'weekYear': productionOrder.weekYear,
                'week': productionOrder.week,
                'mondayDate': startOfWeek(productionOrder.delivery_date, {weekStartsOn: 1}),
                'name': productionOrder.name,
                'totalDeliveries': 1,
                'customers': [productionOrder.customer],
                'totalUniqueDeliveries': 1,
                'smdLoad': 0,
                'thtLoad': 0,
            }
            productionOrderWeekDays.push(newProductionOrderWeekDay)
        } else {
            productionOrderWeekDay[0].customers.push(productionOrder.customer)
            ++productionOrderWeekDay[0].totalDeliveries
            productionOrderWeekDay[0].totalUniqueDeliveries = [...new Set(productionOrderWeekDay[0].customers)].length
            if (productionOrderWeekDay[0][productionOrder.dayWeek] == null) {
                productionOrderWeekDay[0][productionOrder.dayWeek] = [productionOrder]
            } else {
                productionOrderWeekDay[0][productionOrder.dayWeek].push(productionOrder)
            }
        }

        const businessDays = getBusinessDatesCount(productionOrder.start_delivery_date, productionOrder.delivery_date)
        const smdDays = parseInt(businessDays * productionOrder.smd / (productionOrder.smd + productionOrder.tht))
        const thtDays = businessDays - smdDays
        let pointDate = productionOrder.delivery_date
        let pointThtDays = thtDays

        while (pointDate >= productionOrder.start_delivery_date && pointThtDays > 0) {
            if (!(pointDate.isHoliday())) {
                const year = pointDate.getWeekYear()
                const week = pointDate.getWeek()
                if (year * 100 + week in tht)
                    tht[year * 100 + week] += productionOrder.tht / thtDays
                else
                    tht[year * 100 + week] = productionOrder.tht / thtDays
                pointThtDays -= 1
            }
            pointDate = pointDate.addDays(-1)
        }
        let pointSmdDays = smdDays
        while (pointDate >= productionOrder.start_delivery_date && pointSmdDays > 0) {
            if (!(pointDate.isHoliday())) {
                const year = pointDate.getWeekYear()
                const week = pointDate.getWeek()
                if (year * 100 + week in smd)
                    smd[year * 100 + week] += productionOrder.smd / smdDays
                else
                    smd[year * 100 + week] = productionOrder.smd / smdDays
                pointSmdDays -= 1
            }
            pointDate = pointDate.addDays(-1)
        }
    }

    let currentDate = new Date()
    let currentDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay()))
    for (let currentDayOffset of Array(26).keys()) {
        let offsetDay = currentDay.addDays(currentDayOffset * 7)
        let newProductionOrderWeekDay = {
            'weekYear': offsetDay.getWeekYear(),
            'week': offsetDay.getWeek(),
            'mondayDate': startOfWeek(offsetDay, {weekStartsOn: 1}),
            'totalDeliveries': 0,
            'totalUniqueDeliveries': 0,
            'smdLoad': 0,
            'thtLoad': 0,
        }
        let holidays = []
        const dayWeekOffset = [0, 1, 2, 3, 4]
        for (let dayWeek of dayWeekOffset) {
            const dateName = format(offsetDay.addDays(dayWeek), 'yyyyMMdd')
            const holiday = publicHolidays.filter(date => date === dateName)
            if (holiday.length > 0)
                holidays.push(holiday.holiday)
            else
                holidays.push('')
        }
        newProductionOrderWeekDay['holidays'] = holidays
        let existProductionOrders = productionOrderWeekDays.filter(productionOrderWeekDay =>
            productionOrderWeekDay.week == newProductionOrderWeekDay.week &&
            productionOrderWeekDay.weekYear == newProductionOrderWeekDay.weekYear
        )
        if (existProductionOrders.length === 0) {
            productionOrderWeekDays.push(newProductionOrderWeekDay)
        }
    }

    // console.log('tht', tht)
    // console.log('smd', smd)
    for (let productionOrderWeekDay of productionOrderWeekDays) {
        let weekCapacityFiltered = weekCapacity.filter(obj => obj.year === productionOrderWeekDay.weekYear &&
            obj.week === productionOrderWeekDay.week)
        if (weekCapacityFiltered.length > 0) {
            const smd_capacity = weekCapacityFiltered[0].smd_capacity
            const tht_capacity = weekCapacityFiltered[0].tht_capacity
            const smd_goal = weekCapacityFiltered[0].smd_goal
            const tht_goal = weekCapacityFiltered[0].tht_goal

            const date_key = productionOrderWeekDay.weekYear * 100 + productionOrderWeekDay.week
            if (date_key in tht) {
                productionOrderWeekDay['thtLoad'] = tht[date_key] / (tht_goal * tht_capacity)
                // console.log('productionOrderWeekDay THT', productionOrderWeekDay, tht[date_key], tht_goal, tht_capacity)
            }
            if (date_key in smd) {
                productionOrderWeekDay['smdLoad'] = smd[date_key] / (smd_goal * smd_capacity)
                // console.log('productionOrderWeekDay SMD', productionOrderWeekDay)
                // console.log('SMD', date_key, smd[date_key], smd_goal, smd_capacity)
            }
        }
    }
    // console.log('productionOrderWeekDay')
    // console.log(productionOrderWeekDays)
    return productionOrderWeekDays
}

Date.prototype.addDays = function (days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

// Returns the ISO week of the date.
Date.prototype.getWeek = function () {
    var date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
        - 3 + (week1.getDay() + 6) % 7) / 7);
}

// Returns the four-digit year corresponding to the ISO week of the date.
Date.prototype.getWeekYear = function () {
    var date = new Date(this.getTime());
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    return date.getFullYear();
}

Date.prototype.isHoliday = function () {
    const date = new Date(this.getTime());
    const dayWeek = date.getDay();
    const holidayDays = [0, 6];
    return holidayDays.includes(dayWeek);
}

Date.prototype.addWorkDays = function (days) {
    // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
    var dow = this.getDay();
    var daysToAdd = parseInt(days);
    // If the current day is Sunday add one day
    if (dow == 0) {
        daysToAdd++;
    }
    // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
    if (dow + daysToAdd >= 6) {
        //Subtract days in current working week from work days
        var remainingWorkDays = daysToAdd - (5 - dow);
        //Add current working week's weekend
        daysToAdd += 2;
        if (remainingWorkDays > 5) {
            //Add two days for each working week by calculating how many weeks are included
            daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
            //Exclude final weekend if the remainingWorkDays resolves to an exact number of weeks
            if (remainingWorkDays % 5 == 0)
                daysToAdd -= 2;
        }
    }
    this.setDate(this.getDate() + daysToAdd);
};


function getBusinessDatesCount(startDate, endDate) {
    let count = 0;
    let holidayDays = [0, 6]
    const curDate = new Date(startDate.getTime());
    while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if (!holidayDays.includes(dayOfWeek)) count++;
        curDate.setDate(curDate.getDate() + 1);
    }
    return count;
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}